module.exports = __webpack_public_path__ + "static/media/selection-bg-3.fb20cc2d.svg";